import type { ColumnDef } from "@kontextwerk/web-sdk/ui/layout/Table.svelte"
import type { PlanningPreviewRow } from "../../../_shared/_logic/table-contract"

export const buildAppointmentPlanningPreviewColumns = (): ColumnDef[] => {
  const appointmentColumn: ColumnDef = {
    id: "appointment",
    label: "Termin",
    sortable: true,
    sortType: "date",
    defaultSortDir: "asc",
    getSortValue: (row) => (row as PlanningPreviewRow).appointmentSortValue,
  }

  return [
    { id: "property", label: "Liegenschaft", isPrimary: true },
    appointmentColumn,
    { id: "appointmentEmployee", label: "Mitarbeiter" },
    {
      id: "orderType",
      label: "Auftrag",
    },
    { id: "duration", label: "Dauer" },
    {
      id: "planningStrategy",
      label: "Terminierung",
    },
    {
      id: "appointmentType",
      label: "Termintyp",
    },
    { id: "warning", label: "Warnung" },
    { id: "arrival", label: "Anfahrt" },
    { id: "departure", label: "Abfahrt" },
  ]
}
